// helpers/rutaMovimientos.js
import axios from "axios";

// Base del .env o fallback al BACK (no al front)
const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE_URL });

// paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// utilidades
const clean = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );

const up = (s) => (typeof s === "string" ? s.toUpperCase().trim() : s);
const low = (s) => (typeof s === "string" ? s.toLowerCase().trim() : s);

const debugUrl = (url, paramsOrBody) =>
  console.log("👉", API.getUri({ url }), paramsOrBody || "");

/* ========= MOVIMIENTOS ========= */

// GET lista (filtros: { empresa, desde, hasta, tipo, medio, estado, ... })
export const getMovimientos = async (params = {}) => {
  const q = { ...params };

  // normalizaciones opcionales (compat con la ruta del back)
  if (q.tipo) q.tipo = low(q.tipo);                 // "ingreso" | "egreso"
  if (q.medio) q.medio = up(q.medio);               // "EFECTIVO" | ...
  if (q.estado) q.estado = low(q.estado);           // "activo" | "anulado"

  debugUrl(p("movimientos"), q);
  const { data } = await API.get(p("movimientos"), { ...auth(), params: q });
  // esperado: { ok, movimientos, cantidad }
  return data;
};

// GET uno por id
export const getMovimientoById = async (id) => {
  const url = p(`movimientos/${id}`);
  debugUrl(url);
  const { data } = await API.get(url, auth());
  return data; // { ok, movimiento }
};

// POST crear
// Acepta empresa y los campos compat (caja/cuentaBancaria) tal como vienen del form
export const postMovimiento = async (payload) => {
  const body = { ...payload };
  if (body.medio) body.medio = up(body.medio);
  // empresa: la manda tal cual si viene (ObjectId string)
  debugUrl(p("movimientos"), body);
  const { data } = await API.post(p("movimientos"), clean(body), auth());
  return data; // { ok, movimiento }
};

// PUT actualizar
export const putMovimiento = async (id, payload) => {
  const body = { ...payload };
  if (body.medio) body.medio = up(body.medio);
  // empresa: idem POST
  const url = p(`movimientos/${id}`);
  debugUrl(url, body);
  const { data } = await API.put(url, clean(body), auth());
  return data; // { ok, movimiento }
};

// DELETE (baja lógica / anulado)
export const deleteMovimiento = async (id) => {
  const url = p(`movimientos/${id}`);
  debugUrl(url);
  const { data } = await API.delete(url, auth());
  return data; // { ok, movimiento }
};
